// [EN] `dompurify` directly, not `isomorphic-dompurify` — this is a browser-only SPA
//      (src/server.js only serves build/ statically) and every sanitize consumer below
//      is a React component rendering through dangerouslySetInnerHTML. The isomorphic
//      wrapper exists for Node and drags all of jsdom in as a dependency.
// [KO] 이 앱은 SSR 이 없는 브라우저 전용 SPA 이고 아래 sanitize 소비처는 전부
//      dangerouslySetInnerHTML 로 렌더링하는 React 컴포넌트다. isomorphic-dompurify 는
//      Node 환경용이라 jsdom 전체를 의존성으로 끌어오므로 dompurify 를 직접 쓴다.
import DOMPurify from 'dompurify';

const sanitize = (...args: Parameters<typeof DOMPurify.sanitize>): string =>
  DOMPurify.sanitize(...args);

export const createMarkup = (
  html: string,
): {
  __html: string;
} => ({ __html: sanitize(html) });

export const cleanMarkup = ({
  content,
  allowTags,
  allowAttrs,
}: {
  content: string;
  allowTags?: string[];
  allowAttrs?: string[];
}): string => {
  return sanitize(content, { ADD_ATTR: allowAttrs, ADD_TAGS: allowTags });
};
